import React, { useState, useContext } from 'react'
import sublinks from './data'
import App from './App';
 

const AppContext = React.createContext();

export const AppProvider = ({children}) => {
 const [isSidebarOpen, setIsSidebarOpen] = useState(false);
 const [isSubmenu, setIsSubmenu] = useState(false);
 const [location, setLocation] = useState({});
 const [page, setPage] = useState({page:'',
links:[]
})

 const openSidebar = () => {
  setIsSidebarOpen(true);
 }
 const closeSidebar = () => {
  setIsSidebarOpen(false);
 }
 const openSubmenu = (text,coordinates) => {
      const page = sublinks.find((link) => link.page === text)
      setPage(page)
     setLocation(coordinates)
     setIsSubmenu(true);
 }
 const closeSubmenu = () => {
  setIsSubmenu(false);
 }


 return <AppContext.Provider value={{
  isSubmenu,
  isSidebarOpen,
   openSubmenu,
    openSidebar,
     closeSubmenu,
      closeSidebar,
      location,
      page,
 }}>
  {children}
 </AppContext.Provider>
}

export const useGlobalContext = () => {
 return useContext(AppContext)
}